import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const HTIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="HT" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="M0 6v6h16V6H0Z"
          clipRule="evenodd"
        />
        <Path fill="#fff" d="M5 4h6v4H5z" />
        <Mask
          id="c"
          width={6}
          height={4}
          x={5}
          y={4}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path fill="#fff" d="M5 4h6v4H5z" />
        </Mask>
        <G mask="url(#c)">
          <Path
            fill="#279E19"
            fillRule="evenodd"
            d="M5 7.289s1.44-.379 3-.356c1.56.024 3 .445 3 .445V8H5V7.29Z"
            clipRule="evenodd"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M8.037 4.45s-.466-.209-.79-.209c-.326 0-.506.32-.506.32"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M8.14 4.66s-.428-.152-.727-.152a.607.607 0 0 0-.465.233"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M8.14 4.839s-.317-.154-.538-.154c-.221 0-.344.234-.344.234"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M8.01 5.016s-.196-.153-.332-.153c-.137 0-.213.234-.213.234"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M7.993 5.138s-.078-.097-.133-.097c-.054 0-.085.148-.085.148M7.963 4.45s.466-.209.79-.209c.326 0 .506.32.506.32"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M7.86 4.66s.428-.152.727-.152c.3 0 .465.233.465.233"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M7.86 4.839s.317-.154.538-.154c.221 0 .344.234.344.234"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M7.99 5.016s.196-.153.333-.153c.136 0 .212.234.212.234"
          />
          <Path
            stroke="#026A16"
            strokeWidth={0.4}
            d="M8.007 5.138s.078-.097.133-.097c.054 0 .085.148.085.148"
          />
          <Path
            fill="#FECA00"
            fillRule="evenodd"
            d="M7.944 5.2s-.057.668-.057.94c0 .272.057.86.057.86h.147v-.86c0-.227-.086-.94-.086-.94h-.061Z"
            clipRule="evenodd"
          />
          <Path
            fill="#C51918"
            fillRule="evenodd"
            d="M7.366 5.96s-.362.193-.362.767l.362.693h.653V6.279l-.653-.32Z"
            clipRule="evenodd"
          />
          <Path
            fill="#0A328C"
            fillRule="evenodd"
            d="M6.83 5.413s-.846.25-.846 1.174l1.095.094s-.06-.537.278-.785l-.528-.483Z"
            clipRule="evenodd"
          />
          <Path
            stroke="#FFD018"
            strokeWidth={0.4}
            d="m6.48 5.06 1.45 1.33M5.977 5.362l2.022 1.313M5.629 5.87l2.28 1.043"
          />
          <Path
            fill="#FECA00"
            fillRule="evenodd"
            d="m5.99 6.58 1.513.17-.085.21h-.24l.163.12.368.086V6.96h.323v.437h-.691l-.265-.317s-.223.219-.44.219-.431-.071-.431-.31v-.167l-.215-.073V6.58Z"
            clipRule="evenodd"
          />
          <Path
            fill="#C51918"
            fillRule="evenodd"
            d="M8.427 5.96s.362.193.362.767l-.362.693h-.653V6.279l.653-.32Z"
            clipRule="evenodd"
          />
          <Path
            fill="#0A328C"
            fillRule="evenodd"
            d="M8.964 5.413s.845.25.845 1.174l-1.095.094s.06-.537-.277-.785l.527-.483Z"
            clipRule="evenodd"
          />
          <Path
            stroke="#FFD018"
            strokeWidth={0.4}
            d="m9.313 5.06-1.45 1.33M9.816 5.362 7.794 6.675M10.165 5.87l-2.28 1.043"
          />
          <Path
            fill="#FECA00"
            fillRule="evenodd"
            d="m9.803 6.58-1.513.17.086.21h.24l-.164.12-.368.086V6.96H7.76v.437h.691l.265-.317s.223.219.44.219.431-.071.431-.31v-.167l.215-.073V6.58Z"
            clipRule="evenodd"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
